import React from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  array, func, object, number, string, oneOfType,
} from 'prop-types'

import WithTriangleUiContext from 'Pods/Shared/Hocs/WithTriangleUiContext'
import i18n from 'Pods/Shared/I18n'

import useBreakpoint from 'Utils/useBreakpoint'

import PolyCountSlider from '../../../PolyCount/Components/PolyCountSlider'


function RemainingPolyCountFilters({
  currentSelectedFilters,
  initialFrom = null,
  initialTo = null,
  maxPolygonThreshold,
  minPolygonThreshold,
  setSelectedFilters,
  rangeFilters,
  setShouldResetPolygonRange,
  selectedFilters,
  trackFilterChange,
  locale = 'en',
}) {
  const windowSize = useBreakpoint()
  const shouldDisplayTitleDivider = ['xs', 'sm'].includes(windowSize)

  const quickSelectionsLabel = i18n.t('listingPage.filters.quickSelections', { ns: 'rails', lng: locale })

  function handleFilterChange(_, value, isOn) {
    const selectedPolygonRangeFilters = selectedFilters.polygonRange || []
    const newPolygonRangeFilters = isOn
      ? [...selectedPolygonRangeFilters, value]
      : selectedPolygonRangeFilters.filter((item) => item !== value)
    setSelectedFilters({ name: 'polygonRange', value: newPolygonRangeFilters })

    if (isOn) {
      trackFilterChange({ name: 'polygonRange', value })
    } else {
      window.removeCurrentSearchFilter({ name: 'polygonRange', value })
    }

    const rangeFiltersList = rangeFilters.map(item => item.value)
    if (!rangeFiltersList.includes(value)) {
      setShouldResetPolygonRange(true)
    }
  }

  return (
    <div className="remaining-filters__poly-count">
      <PolyCountSlider
        initialFrom={initialFrom}
        initialTo={initialTo}
        maxPolygonThreshold={maxPolygonThreshold}
        minPolygonThreshold={minPolygonThreshold}
        setSelectedFilters={setSelectedFilters}
        withTitleDivider={shouldDisplayTitleDivider}
      />
      <div className="remaining-filters__quick-selections">
        <FiltersSidebar
          isCollapsible={false}
          filters={[{ filters: rangeFilters, label: quickSelectionsLabel }]}
          selectedFilters={currentSelectedFilters}
          onFiltersChange={handleFilterChange}
          isControlled
          hideLastDivider
          useNewCheckboxes
          hideShowMore
        />
      </div>
    </div>
  )
}

RemainingPolyCountFilters.propTypes = {
  currentSelectedFilters: array.isRequired,
  initialFrom: oneOfType([string, number]),
  initialTo: oneOfType([string, number]),
  maxPolygonThreshold: number.isRequired,
  minPolygonThreshold: number.isRequired,
  setSelectedFilters: func.isRequired,
  rangeFilters: array.isRequired,
  setShouldResetPolygonRange: func.isRequired,
  selectedFilters: object.isRequired,
  trackFilterChange: func.isRequired,
  locale: string,
}

const mapStateToProps = ({
  selectedFilters,
  setSelectedFilters,
  filtersOptions,
  maxPolygonThreshold,
  minPolygonThreshold,
  setShouldResetPolygonRange,
  trackFilterChange,
  locale,
}) => {
  const rangeFilters = filtersOptions.polygons.filters
  const rangeFiltersList = rangeFilters.map(({ value }) => value)
  const selectedPolygonRangeFilters = selectedFilters.polygonRange || []
  const customPolygonRange = selectedPolygonRangeFilters.find(value => !rangeFiltersList.includes(value))
  const [initialFrom, initialTo] = (() => {
    if (customPolygonRange) {
      const splitValue = customPolygonRange.split('_').slice(1)
      return [splitValue[0], splitValue[1]]
    }

    return [undefined, undefined]
  })()
  const currentSelectedFilters = selectedPolygonRangeFilters.filter(Boolean)

  return {
    currentSelectedFilters,
    initialFrom,
    initialTo,
    maxPolygonThreshold,
    minPolygonThreshold,
    setSelectedFilters,
    rangeFilters,
    setShouldResetPolygonRange,
    selectedFilters,
    trackFilterChange,
    locale,
  }
}

export default WithTriangleUiContext(mapStateToProps)(RemainingPolyCountFilters)
